import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import './Outline.css';

export function SectionNode({
  section,
  isSelected,
  onSelect,
  onExpand,
  isExpanded,
  depth = 0
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id: section.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    marginLeft: `${depth * 20}px`
  };

  const hasContent = section.has_content || section.generated_content;
  const hasSubSections = section.sub_sections && section.sub_sections.length > 0;
  const workshopCount = section.workshop_count || 0;

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`section-node ${isSelected ? 'section-node--selected' : ''} ${isDragging ? 'section-node--dragging' : ''}`}
      onClick={() => onSelect(section)}
    >
      <div className="section-node__content">
        <span
          className="section-node__drag-handle"
          {...attributes}
          {...listeners}
        >
          ⋮⋮
        </span>

        {hasSubSections && (
          <button
            className="section-node__expand-btn"
            onClick={(e) => {
              e.stopPropagation();
              onExpand(section.id);
            }}
          >
            {isExpanded ? '▼' : '▶'}
          </button>
        )}

        <span className="section-node__type-badge">
          {section.section_type}
        </span>

        <span className="section-node__name">
          {section.display_name}
        </span>

        <div className="section-node__indicators">
          {hasContent && (
            <span className="section-node__indicator section-node__indicator--content" title="Has generated content">
              ✓
            </span>
          )}
          {workshopCount > 0 && (
            <span className="section-node__indicator section-node__indicator--workshops" title={`${workshopCount} workshop(s)`}>
              {workshopCount}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

export default SectionNode;
